import { useContext, useEffect, useState } from 'react';
import { Modal, Stack, useMediaQuery } from '@mui/material';
import { Theme } from 'Theme';
import { useIsDesktop } from 'Hooks';
import { CloseButton } from './CloseButton';
import { Form } from './Form';
import { CannabisContext, IInvoice } from 'Context/CannabisContext';

export const NewInvoiceForm = () => {
  const { showForm, newInvoice } = useContext(CannabisContext);
  const [OcrInvoice] = useState<IInvoice>(newInvoice);

  const isScreenXl = useMediaQuery(Theme.breakpoints.up('xl'));
  const isDesktop = useIsDesktop();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  return (
    <Modal
      open={showForm}
      sx={{
        zIndex: '2',
      }}
    >
      <Stack
        sx={{
          width: '100%',
          height: '100%',
          bgcolor: 'white',
          mt: isDesktop ? '80px' : undefined,
          ml: isScreenXl ? '300px' : undefined,
          pl: isDesktop ? (isScreenXl ? '300px' : '72px') : undefined,
          position: 'relative',
          direction: 'ltr',
        }}
      >
        <Stack
          sx={{
            height: isDesktop ? 'calc(100vh - 100px)' : undefined,
            overflowY: isDesktop ? 'scroll' : 'auto',
          }}
        >
          <CloseButton />
          <Form invoice={OcrInvoice} />
        </Stack>
      </Stack>
    </Modal>
  );
};
